import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import ButtonScaleView, {
  ButtonScaleViewOpts,
} from 'src/lib/ui/components/ButtonScaleView';

export default class TeamTab extends ButtonScaleView {
  public get label() {
    return this._label.localeText?.() ?? '';
  }

  public set label(v: string) {
    this._label.localeText = () => i18n(v);
  }
  private readonly _label: LangBitmapFontTextView;

  public get active() {
    return this._active;
  }

  public set active(v: boolean) {
    this._active = v;
    this.updateButtonImages({
      image: `assets/ui/match2/team/team_tab${v ? '_active' : ''}.png`,
    });
    this._label.updateOpts({ color: v ? '#76233C' : '#814352' });
  }
  private _active = false;

  constructor(opts: ButtonScaleViewOpts) {
    super({
      image: 'assets/ui/match2/team/team_tab.png',
      ...opts,
    });

    const padding = 30;
    this._label = new LangBitmapFontTextView({
      superview: this,
      font: 'Body',
      size: 38,
      color: '#814352',
      align: 'center',
      verticalAlign: 'center',
      x: padding / 2,
      width: -padding + (opts.width ?? 0),
      height: opts.height,
      localeText: () => '[Label]',
    });
  }
}
